import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

const SCHEMES = [
  { id: "theme-navy-gold", name: "Navy Blue & Gold — Classic Authority" },
  { id: "theme-electric-cyan", name: "Electric Blue & Cyan — Modern Tech" },
  { id: "theme-royal-saffron", name: "Royal Blue & Saffron — Warm Indian" },
  { id: "theme-purple-gold", name: "Deep Purple & Gold — Bold Futuristic" },
  { id: "theme-forest-gold", name: "Forest Green & Gold — Fresh Natural" },
  { id: "theme-crimson-silver", name: "Crimson Red & Silver — Bold Energetic" },
];
export { SCHEMES };

export function SiteProvider({ children }) {
  const [data, setData] = useState(null);
  const [scheme, setSchemeState] = useState("theme-navy-gold");
  const [light, setLight] = useState(() => localStorage.getItem("bnb_light") === "1");

  const applyTheme = useCallback((schemeId, isLight) => {
    const el = document.documentElement;
    el.className = `${schemeId}${isLight ? " light" : ""}`;
  }, []);

  const setScheme = useCallback((id) => {
    setSchemeState(id);
    applyTheme(id, light);
  }, [applyTheme, light]);

  const toggleLight = useCallback(() => {
    setLight((prev) => {
      const next = !prev;
      localStorage.setItem("bnb_light", next ? "1" : "0");
      applyTheme(scheme, next);
      return next;
    });
  }, [applyTheme, scheme]);

  const refresh = useCallback(async () => {
    const { data } = await api.get("/bootstrap");
    setData(data);
    const s = data?.settings?.color_scheme || "theme-navy-gold";
    setSchemeState(s);
    applyTheme(s, localStorage.getItem("bnb_light") === "1");
    return data;
  }, [applyTheme]);

  useEffect(() => {
    applyTheme(scheme, light);
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SiteContext.Provider value={{ data, refresh, scheme, setScheme, light, toggleLight }}>
      {children}
    </SiteContext.Provider>
  );
}
